// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.export-buttons {
  display: flex;
  gap: 10px;
}

.btn-export {
  padding: 8px 16px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-export:hover {
  background: #1565c0;
}

.user-list {
  max-width: 1400px;
}

.user-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.user-list-header h2 {
  margin: 0;
  color: #333;
  font-size: 24px;
}

.search-box input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 300px;
}

.user-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.user-table {
  width: 100%;
  border-collapse: collapse;
}

.user-table thead {
  background: #f5f5f5;
}

.user-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
  font-size: 14px;
  border-bottom: 2px solid #e0e0e0;
}

.user-table td {
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
}

.user-table tbody tr:hover {
  background: #f9f9f9;
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  margin-right: 5px;
}

.status-badge.active {
  background: #4caf50;
  color: white;
}

.status-badge.inactive {
  background: #f44336;
  color: white;
}

.status-badge.trial {
  background: #ff9800;
  color: white;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.action-buttons button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.btn-view {
  background: #1976d2;
  color: white;
}

.btn-view:hover {
  background: #1565c0;
}

.btn-reset {
  background: #ff9800;
  color: white;
}

.btn-reset:hover {
  background: #f57c00;
}

.btn-disable {
  background: #f44336;
  color: white;
}

.btn-disable:hover {
  background: #d32f2f;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
}

.pagination button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination button:not(:disabled):hover {
  background: #f5f5f5;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

@media (max-width: 768px) {
  .user-table-container {
    overflow-x: scroll;
  }

  .user-list-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .search-box input {
    width: 100%;
  }
}


/* ── Bulk Actions ── */

.bulk-actions-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  margin-bottom: 16px;
}

.bulk-count {
  font-weight: 600;
  font-size: 14px;
  color: #1d4ed8;
  white-space: nowrap;
}

.bulk-action-select {
  padding: 6px 10px;
  border: 1px solid #93c5fd;
  border-radius: 6px;
  font-size: 13px;
  background: white;
  min-width: 220px;
}

.btn-bulk-apply {
  padding: 6px 16px;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-bulk-apply:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-bulk-apply:hover:not(:disabled) {
  background: #1d4ed8;
}

.btn-bulk-cancel {
  padding: 6px 12px;
  background: transparent;
  color: #666;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.btn-bulk-cancel:hover {
  background: #f3f4f6;
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/UserList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA,uBAAuB;;AAEvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".user-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.export-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-export {\n  padding: 8px 16px;\n  background: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.btn-export:hover {\n  background: #1565c0;\n}\n\n.user-list {\n  max-width: 1400px;\n}\n\n.user-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.user-list-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 24px;\n}\n\n.search-box input {\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  width: 300px;\n}\n\n.user-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.user-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.user-table thead {\n  background: #f5f5f5;\n}\n\n.user-table th {\n  padding: 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.user-table td {\n  padding: 12px;\n  border-bottom: 1px solid #e0e0e0;\n  font-size: 14px;\n}\n\n.user-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-right: 5px;\n}\n\n.status-badge.active {\n  background: #4caf50;\n  color: white;\n}\n\n.status-badge.inactive {\n  background: #f44336;\n  color: white;\n}\n\n.status-badge.trial {\n  background: #ff9800;\n  color: white;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.action-buttons button {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s;\n}\n\n.btn-view {\n  background: #1976d2;\n  color: white;\n}\n\n.btn-view:hover {\n  background: #1565c0;\n}\n\n.btn-reset {\n  background: #ff9800;\n  color: white;\n}\n\n.btn-reset:hover {\n  background: #f57c00;\n}\n\n.btn-disable {\n  background: #f44336;\n  color: white;\n}\n\n.btn-disable:hover {\n  background: #d32f2f;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.pagination button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: white;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination button:not(:disabled):hover {\n  background: #f5f5f5;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n@media (max-width: 768px) {\n  .user-table-container {\n    overflow-x: scroll;\n  }\n\n  .user-list-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .search-box input {\n    width: 100%;\n  }\n}\n\n\n/* ── Bulk Actions ── */\n\n.bulk-actions-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 8px;\n  margin-bottom: 16px;\n}\n\n.bulk-count {\n  font-weight: 600;\n  font-size: 14px;\n  color: #1d4ed8;\n  white-space: nowrap;\n}\n\n.bulk-action-select {\n  padding: 6px 10px;\n  border: 1px solid #93c5fd;\n  border-radius: 6px;\n  font-size: 13px;\n  background: white;\n  min-width: 220px;\n}\n\n.btn-bulk-apply {\n  padding: 6px 16px;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.btn-bulk-apply:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-bulk-apply:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.btn-bulk-cancel {\n  padding: 6px 12px;\n  background: transparent;\n  color: #666;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.btn-bulk-cancel:hover {\n  background: #f3f4f6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
